document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.page-header');

    function handleHeaderOnScroll() {
        const jsPhTop = document.querySelector('.js-ph-top');
        if (window.innerWidth > 1199) {
            if (window.scrollY > 0) {
                header.style.top = `-${jsPhTop.offsetHeight + 1 + 10}px`;
                header.classList.add('bg');
            } else {
                header.style.top = '';
                header.classList.remove('bg');
            }
        } else {
            if (window.scrollY > 0) {
                header.style.top = '0px';
                header.classList.add('bg');
            } else {
                header.style.top = '0px';
                header.classList.remove('bg');
            }
        }
    }

    window.addEventListener('scroll', handleHeaderOnScroll);
    window.addEventListener('resize', handleHeaderOnScroll);
    window.addEventListener('load', handleHeaderOnScroll);


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = this.getAttribute('href');
            smoothScroll(target, 800);
            setTimeout(() => {
                // const header = document.querySelector('.page-header');
                // let lastScrollTop = 0;
                const headerHeight = header.offsetHeight;
                header.style.transform = `translateY(-${headerHeight}px)`; // Scrolling down

            }, 850);
        });
    });
});

document.querySelector('.menu-toggle').addEventListener('click', function() {
    this.classList.toggle('active');
    document.querySelector('.page-header').classList.toggle('header-active');
    document.querySelector('.js-ph-mobile').classList.toggle('nav-open');
    document.body.classList.toggle('body-overflow');
});

document.querySelectorAll('.menu-item a[href*="#"]').forEach(link => {
    link.addEventListener('click', function (e) {
        document.querySelector('.menu-toggle').classList.remove('active');
        document.querySelector('.page-header').classList.remove('header-active');
        document.querySelector('.js-ph-mobile').classList.remove('nav-open');
        document.body.classList.remove('body-overflow');

        const href = this.getAttribute('href');
        if (!href || !href.includes('#')) return;

        const [url, hash] = href.split('#');
        const currentUrl = window.location.pathname.replace(/\/$/, '');
        const linkUrl = url ? new URL(url, window.location.origin).pathname.replace(/\/$/, '') : currentUrl;

        if (linkUrl === currentUrl) {
            // Same page
            const target = document.getElementById(hash);
            if (target) {
                e.preventDefault();
                const header = document.querySelector('.page-header');
                const offset = header ? header.offsetHeight : 0;
                const top = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        } else {
            // Different page
            // Let the browser navigate, but add scroll-to-anchor after load
            // Optionally, you can use localStorage/sessionStorage to pass scroll info
        }
    });
});

// Optional: On page load, scroll to anchor if present in URL
window.addEventListener('DOMContentLoaded', function () {
    if (window.location.hash) {
        const id = window.location.hash.substring(1);
        const target = document.getElementById(id);
        if (target) {
            const header = document.querySelector('.page-header');
            const offset = header ? header.offsetHeight : 0;
            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }
});
